export const IMG_BASE_URL = "http://172.20.10.13:8088/img";